export default "__VITE_ASSET__62187f33__"